var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecommendedItemIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_639_18106)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.9968 28.7569L37.0704 0L33.0011 28.9189L46.7057 3.1297L33.9018 29.379L54.909 9.09102L34.621 30.0982L60.8638 17.2878L35.0811 30.9989L64 26.9296L35.2366 31.9968L64 37.0704L35.0811 33.0011L60.8638 46.7057L34.621 33.9018L54.909 54.909L33.9018 34.621L46.7057 60.8638L33.0011 35.0811L37.0704 64L31.9968 35.2366L26.9296 64L30.9989 35.0811L17.2878 60.8638L30.0982 34.621L9.09102 54.909L29.379 33.9018L3.1297 46.7057L28.9189 33.0011L0 37.0704L28.7569 31.9968L0 26.9296L28.9189 30.9989L3.1297 17.2878L29.379 30.0982L9.09102 9.09102L30.0982 29.379L17.2878 3.1297L30.9989 28.9189L26.9296 0L31.9968 28.7569Z",
    fill: "#231F20"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_639_18106"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecommendedItemIcon2);
export default __webpack_public_path__ + "static/media/recommendedItemIcon2.7613183c94db1f63005c30b0426a74a8.svg";
export { ForwardRef as ReactComponent };